import { __decorate, __param } from 'tslib';
import { Injectable, Optional, SkipSelf, NgModule } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { SpeNPrePixProxy, SpeViewNPrePixProxy, UiPxPrePixModule } from '@wlp/ui-px-pre-pix';
import { DocumentValidator, UiBsUtilModule } from '@wlp/ui-bs-util';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

// @Injectable({
//   providedIn: 'root'
// })
let PrePixService = class PrePixService {
    constructor(formBuilder, speNPrePixProxy, speViewNPrePixProxy) {
        this.formBuilder = formBuilder;
        this.speNPrePixProxy = speNPrePixProxy;
        this.speViewNPrePixProxy = speViewNPrePixProxy;
        this.errorMessages = {
            docNumber: [
                { type: 'cpfNotValid', message: 'PIX.CHOOSE_KEY.FORM.CPF.MESSAGE.CPF_NOT_VALID' },
                { type: 'cnpjNotValid', message: 'PIX.CHOOSE_KEY.FORM.CNPJ.MESSAGE.CNPJ_NOT_VALID' },
            ],
            email: [
                {
                    type: 'minlength',
                    message: 'PIX.CHOOSE_KEY.FORM.E_MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'PIX.CHOOSE_KEY.FORM.E_MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'PIX.CHOOSE_KEY.FORM.E_MAIL.MESSAGE.PATTERN' },
            ],
            phone: [
                {
                    type: 'minlength',
                    message: 'PIX.CHOOSE_KEY.FORM.PHONE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 11 }
                },
            ],
        };
        this.behaviorPixForm = new BehaviorSubject(this.getInitialBehaviourPixForm());
        this.behaviorModalVisibility = new BehaviorSubject(true);
    }
    getInitialBehaviourPixForm() {
        return ({
            dateRegister: "",
            accepted: "",
            text: "",
            cpf: "",
            cnpj: "",
            phone: "",
            email: "",
            evp: "",
            type_person: "",
            type_account: "",
            brand: "",
            account: "",
            uuidWL: "",
            uuidUser: "",
            reason: "",
            uuidAccountPayment: "",
            name: ""
        });
    }
    getFormPrePix() {
        this.prePix = this.formBuilder.group({
            docNumber: new FormControl('', Validators.compose([DocumentValidator.isValidCPFCNPJ])),
            email: new FormControl('', Validators.compose([
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
            phone: new FormControl('', Validators.compose([
                Validators.minLength(13),
            ])),
            docNumberCheck: new FormControl(false, Validators.compose([])),
            emailCheck: new FormControl(false, Validators.compose([])),
            phoneCheck: new FormControl(false, Validators.compose([]))
        });
        return this.prePix;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo do PrePix
     */
    setPixByFormGroup(form) {
        this.behaviorPixForm.next(Object.assign({}, this.behaviorPixForm.getValue(), this.prepareForm(form)));
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo do PrePix
     */
    setPixByObject(prePix) {
        this.behaviorPixForm.next(Object.assign({}, this.behaviorPixForm.getValue(), prePix));
    }
    /**
     * @description Método retorna o formulario do PrePix
     */
    getPrePixFormFromBehavior() {
        return this.behaviorPixForm;
    }
    /**
     * @description Método que seta a visibilidade do modal de confirmação
     */
    setModalVisibility(flag) {
        this.behaviorModalVisibility.next(flag);
    }
    /**
     * @description Método que retorna a visibilidade do modal confirmação
     */
    getModalVisibility() {
        return this.behaviorModalVisibility;
    }
    /**
     * @description Método recebe o form e transforma no corpo para o fluxo do PrePix
     */
    prepareForm(form) {
        return Object.assign({}, form.getRawValue());
    }
    /**
     * @description Método que destroi o behaviorPixForm
     */
    unSubscribe() {
        this.behaviorPixForm = new BehaviorSubject(this.getInitialBehaviourPixForm());
    }
    getPrePix(uuidWL, uuidUser) {
        return this.speViewNPrePixProxy.getPrePix(uuidWL, uuidUser);
    }
    getAllPrePix(uuidWL) {
        return this.speViewNPrePixProxy.getPrePixAll(uuidWL);
    }
    createPrePix(form) {
        return this.speNPrePixProxy.createPrePix(form);
    }
    updatePrePix(uuidWL, uuidUser, form) {
        return this.speNPrePixProxy.updatePrePix(uuidUser, uuidWL, form);
    }
    /**
     * Retorna um conjunto de keys que ainda não foram informadas pelo usuario
     * @param uuidWL
     * @param uuidUser
     */
    checkUserKeys(uuidWL, uuidUser) {
        return this.speViewNPrePixProxy.checkUserKeys(uuidWL, uuidUser);
    }
};
PrePixService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNPrePixProxy },
    { type: SpeViewNPrePixProxy }
];
PrePixService = __decorate([
    Injectable()
], PrePixService);

var UiBsPrePixModule_1;
let UiBsPrePixModule = UiBsPrePixModule_1 = class UiBsPrePixModule {
    constructor(parentModule) {
        //.....
    }
    static forRoot(config) {
        return {
            ngModule: UiBsPrePixModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsPrePixModule.ctorParameters = () => [
    { type: UiBsPrePixModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsPrePixModule = UiBsPrePixModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            RxReactiveFormsModule,
            UiBsUtilModule,
            UiPxPrePixModule
        ],
        providers: [
            PrePixService
        ],
        exports: [
            RxReactiveFormsModule
        ]
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsPrePixModule);

/*
 * Public API Surface of ui-bs-pre-pix
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PrePixService, UiBsPrePixModule };
//# sourceMappingURL=wlp-ui-bs-pre-pix.js.map
